import { each } from "lodash";
import { isCardWithRequest } from "@radarly/models/cards/is";
import { isCardRow } from "@radarly/models/insight-pages/row";
import { ImageClustersData } from "@radarly/models/insights";
import { PublicPage } from "@radarly/models/public-pages";
import {
  SearchData,
  SearchFragment,
  SearchParams,
} from "@radarly/models/search";
import { InsightsRepository } from "./InsightsRepository";

export class PublicInsightsRepository implements InsightsRepository {
  private data: Record<string, SearchData> = {};
  constructor(publicPage: PublicPage) {
    each(publicPage.customPage.rows, (row) => {
      if (isCardRow(row)) {
        each(row.cards, (card) => {
          if (card && isCardWithRequest(card)) {
            each(card.fragments, (fragment: SearchFragment) => {
              this.data[fragment.request.id] = fragment.data;
            });
          }
        });
      }
    });
  }

  public async getImageClusters(
    projectId: number,
    query: SearchParams
  ): Promise<ImageClustersData> {
    if (query) {
      return (this.data[query.id] || null) as unknown as ImageClustersData;
    }
  }
}
